import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/logo.png";

const Header: React.FC = () => {
  const { user, isAdmin, signOut } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-gray-900 text-white py-4">
      <div className="container mx-auto px-4">
        {/* Desktop and Mobile Top Bar */}
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src={logo}
              alt="West Coast Drywall & Paint Logo"
              className="h-10 md:h-12 mr-3 md:mr-4"
            />
            <div>
              <h1 className="text-lg md:text-2xl font-bold leading-tight">
                <span className="hidden sm:inline">Department of West Coast Efficiency</span>
                <span className="sm:hidden">DOWCE</span>
              </h1>
              <p className="text-xs md:text-sm text-gray-400 hidden sm:block">
                Saving money through operational excellence since 2024
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <nav>
              <ul className="flex space-x-6">
                <li>
                  <Link
                    to="/"
                    className="hover:text-yellow-300 transition-colors"
                  >
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    to="/receipts"
                    className="hover:text-yellow-300 transition-colors"
                  >
                    Wall of Receipts
                  </Link>
                </li>
                {isAdmin && (
                  <li>
                    <Link
                      to="/admin"
                      className="hover:text-yellow-300 transition-colors"
                    >
                      Admin
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
            {user && (
              <div className="flex items-center space-x-4 ml-4 pl-4 border-l border-gray-700">
                <span className="text-sm text-gray-400">{user.email}</span>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 hover:bg-red-700 text-white text-sm font-bold py-1 px-3 rounded transition-colors"
                >
                  Logout
                </button>
              </div>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded hover:bg-gray-800 transition-colors"
            onClick={toggleMobileMenu}
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {mobileMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden mt-4 pt-4 border-t border-gray-700">
            <nav className="mb-4">
              <ul className="space-y-3">
                <li>
                  <Link
                    to="/"
                    className="block py-2 hover:text-yellow-300 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Dashboard
                  </Link>
                </li>
                <li>
                  <Link
                    to="/receipts"
                    className="block py-2 hover:text-yellow-300 transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    Wall of Receipts
                  </Link>
                </li>
                {isAdmin && (
                  <li>
                    <Link
                      to="/admin"
                      className="block py-2 hover:text-yellow-300 transition-colors"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      Admin
                    </Link>
                  </li>
                )}
              </ul>
            </nav>
            {user && (
              <div className="pt-4 border-t border-gray-700">
                <p className="text-sm text-gray-400 mb-3">{user.email}</p>
                <button
                  onClick={handleLogout}
                  className="bg-red-600 hover:bg-red-700 text-white text-sm font-bold py-2 px-4 rounded transition-colors w-full"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
